let accessToken = null;
let isRefreshing = false;
let refreshSubscribers = [];

export const tokenManager = {
  getToken: () => {
    // Check memory first
    if (accessToken) return accessToken;
    
    // Check sessionStorage for impersonation token (survives refresh)
    const sessionToken = sessionStorage.getItem('impersonation_token');
    if (sessionToken) {
      accessToken = sessionToken;
      return accessToken;
    }
    
    return null;
  },
  
  setToken: (token, isImpersonating = false) => {
    accessToken = token;
    
    // If impersonating, store in sessionStorage to survive refresh
    if (isImpersonating) {
      sessionStorage.setItem('impersonation_token', token);
    } else {
      // Clear any existing impersonation token when setting normal token
      sessionStorage.removeItem('impersonation_token');
    }
  },
  
  clearToken: () => {
    accessToken = null;
    sessionStorage.removeItem('impersonation_token');
  },
  
  isRefreshing: () => isRefreshing,
  
  setIsRefreshing: (state) => {
    isRefreshing = state;
  },
  
  // Observer pattern for queuing requests while refreshing
  onRefreshed: (token) => {
    refreshSubscribers.map((cb) => cb(token));
    refreshSubscribers = [];
  },
  
  subscribeTokenRefresh: (cb) => {
    refreshSubscribers.push(cb);
  }
};
